import React from 'react'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const BackdropLoader=(props)=> {
    return (
        <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.modal + 1 })}
            open={props.open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default BackdropLoader
